import React, { useState, ChangeEvent } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { ListUsersSessionMessage } from "./ListUsers/ListUsersSessionMessage";
import { useIntl } from "react-intl";

interface ModalProps {
  showModal: boolean;
  closeModal: () => void;
  modalTitle: string;
  modalMessage: string;
  handleModalMessageChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const ComponentModal: React.FC<ModalProps> = ({
  showModal,
  closeModal,
  modalTitle,
  modalMessage,
  handleModalMessageChange,
}) => {
  const intl = useIntl();
  return (
    <Modal show={showModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="formModalMessage">
            <Form.Label>
              {" "}
              {intl.formatMessage({
                id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
              })}
            </Form.Label>
            <Form.Control
              type="text"
              value={modalMessage}
              onChange={handleModalMessageChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={closeModal}>
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.CLOSE",
          })}
        </Button>
        <Button variant="primary" onClick={closeModal}>
          {intl.formatMessage({
            id: "MENU.DASHBOARD_PLANS_SALES.SAVE",
          })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const AutomaticMessageView: React.FC = () => {
  const [showModal_1, setShowModal_1] = useState(false);
  const [modalMessage_1, setModalMessage_1] = useState("");
  const [showModal_2, setShowModal_2] = useState(false);
  const [modalMessage_2, setModalMessage_2] = useState("");
  const [showModal_3, setShowModal_3] = useState(false);
  const [modalMessage_3, setModalMessage_3] = useState("");

  const [showModal_4, setShowModal_4] = useState(false);
  const [modalMessage_4, setModalMessage_4] = useState("");
  const [showModal_5, setShowModal_5] = useState(false);
  const [modalMessage_5, setModalMessage_5] = useState("");
  const [showModal_6, setShowModal_6] = useState(false);
  const [modalMessage_6, setModalMessage_6] = useState("");

  const [showModal_7, setShowModal_7] = useState(false);
  const [modalMessage_7, setModalMessage_7] = useState("");
  const [showModal_8, setShowModal_8] = useState(false);
  const [modalMessage_8, setModalMessage_8] = useState("");
  const [showModal_9, setShowModal_9] = useState(false);
  const [modalMessage_9, setModalMessage_9] = useState("");

  const handleOpenModal = (
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    setShowModal(true);
  };

  const handleCloseModal = (
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
  ) => {
    setShowModal(false);
  };

  const handleModalMessageChange = (
    e: ChangeEvent<HTMLInputElement>,
    setModalMessage: React.Dispatch<React.SetStateAction<string>>
  ) => {
    setModalMessage(e.target.value);
  };
  const intl = useIntl();
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LAST_ACESS",
                })}
                (10{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_1)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LAST_ACESS",
                })}{" "}
                (20{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_2)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-7 col-md-7 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LAST_ACESS",
                })}{" "}
                (30{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_3)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DEFAULTER_ONLY",
                })}{" "}
                (10{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_4)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DEFAULTER_ONLY",
                })}{" "}
                (20{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_5)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-7 col-md-7 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DEFAULTER_ONLY",
                })}{" "}
                (30{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_6)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LIST_VISITOR",
                })}{" "}
                (10{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_7)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LIST_VISITOR",
                })}{" "}
                (20{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_8)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>

          <div className="col-sm-7 col-md-6 col-lg-4 col-xl-4 col-xxl-4 p-0">
            <div className="card card-body align-items-center m-2 p-0">
              <h5 className="card-title border-bottom border-dark d-flex align-items-center m-5">
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.LIST_VISITOR",
                })}{" "}
                (30{" "}
                {intl.formatMessage({
                  id: "MENU.DASHBOARD_PLANS_SALES.DAYS",
                })}
                )
                <Button
                  className="btn btn-primary ms-10 m-2"
                  onClick={() => handleOpenModal(setShowModal_9)}
                >
                  {intl.formatMessage({
                    id: "MENU.DASHBOARD_PLANS_SALES.MESSAGE",
                  })}
                </Button>
              </h5>
              <ListUsersSessionMessage cardHeight="350px" />
            </div>
          </div>
        </div>
      </div>

      <ComponentModal
        showModal={showModal_1}
        closeModal={() => handleCloseModal(setShowModal_1)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_1}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_1)
        }
      />

      <ComponentModal
        showModal={showModal_2}
        closeModal={() => handleCloseModal(setShowModal_2)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_2}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_2)
        }
      />

      <ComponentModal
        showModal={showModal_3}
        closeModal={() => handleCloseModal(setShowModal_3)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_3}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_3)
        }
      />

      <ComponentModal
        showModal={showModal_4}
        closeModal={() => handleCloseModal(setShowModal_4)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_4}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_4)
        }
      />

      <ComponentModal
        showModal={showModal_5}
        closeModal={() => handleCloseModal(setShowModal_5)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_5}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_5)
        }
      />

      <ComponentModal
        showModal={showModal_6}
        closeModal={() => handleCloseModal(setShowModal_6)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_6}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_6)
        }
      />

      <ComponentModal
        showModal={showModal_7}
        closeModal={() => handleCloseModal(setShowModal_7)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_7}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_7)
        }
      />

      <ComponentModal
        showModal={showModal_8}
        closeModal={() => handleCloseModal(setShowModal_8)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_8}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_8)
        }
      />

      <ComponentModal
        showModal={showModal_9}
        closeModal={() => handleCloseModal(setShowModal_9)}
        modalTitle={intl.formatMessage({
          id: "MENU.DASHBOARD_PLANS_SALES.EDIT_MESSAGE",
        })}
        modalMessage={modalMessage_9}
        handleModalMessageChange={(e) =>
          handleModalMessageChange(e, setModalMessage_9)
        }
      />
    </>
  );
};

export default AutomaticMessageView;
